/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".detailsListDragDropExample .dragEnter{background-color:"},{"theme":"neutralLight","defaultValue":"#eaeaea"},{"rawString":"}"}]);
/* tslint:enable */